import { useContext, useEffect, useState } from "react";
import DataContext from "../../../store/data-context";

export default function useGetItems() {
  const [items, setItems] = useState([]);
  const [lastCat, setLastCat] = useState([]);
  const [reqSent, setReqSent] = useState([false]);
  const dataCtx = useContext(DataContext);

  const getItems = async (
    category = [],
    productCounter = 0,
    setProductCounter = () => {}
  ) => {
    if (category.length !== 0) {
      category = "&category=" + category.join();
    }

    if (items === -1 || items === -2) {
      setItems([]);
    }

    if (productCounter < 50) {
      setItems([]);
    }

    try {
      setReqSent(true);

      console.log("STARTED GETTING DATA");
      const response = await fetch(
        `https://hogast.hr/wp/wp-json/custom/v1/products?per_page=50${category}&offset=${productCounter}&lang=${
          dataCtx.lang.lang || "hr"
        }`,
        {
          mode: "cors",
        }
      );

      if (response.ok) {
        let value = await response.json();

        if (value.length === 0) {
          value = -1;
        } else if (productCounter !== 0 && productCounter === items.length) {
          value = [...items, ...value];
        }

        if (value.length > productCounter) {
          setProductCounter(productCounter + 50);
        }

        setReqSent(false);
        setItems(value);
      }
    } catch (err) {
      setItems(-2);
      setReqSent(false);
      console.log("Loading error: ", err.message);
    }
  };

  return [items, getItems, reqSent];
}
